var visibilityChangeApiMap = function() {
    if (typeof document === "object") {
        if (document.hidden !== undefined) {
            return {
                hidden: "hidden",
                visibilityChange: "visibilitychange"
            };
        // @ts-ignore 特性检测
        } else if (document.webkitHidden !== undefined) {
            return {
                hidden: "webkitHidden",
                visibilityChange: "webkitvisibilitychange"
            };
        // @ts-ignore 特性检测
        } else if (document.msHidden !== undefined) {
            return {
                hidden: "msHidden",
                visibilityChange: "msvisibilitychange"
            };
        }
    }
    return false;
}();
var supportVisibilityChange = !!visibilityChangeApiMap;
var watchPageVisibilityChange = function watchPageVisibilityChange(callback) {
    var once = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (supportVisibilityChange) {
        var visibilityChangeCallback = function() {
            if (once) {
                document.removeEventListener(visibilityChangeApiMap.visibilityChange, visibilityChangeCallback);
            }
            // @ts-ignore 特性检测
            callback(!document[visibilityChangeApiMap.hidden]);
        };
        document.addEventListener(visibilityChangeApiMap.visibilityChange, visibilityChangeCallback);
    }
};
export { supportVisibilityChange, watchPageVisibilityChange };

 //# sourceMappingURL=visibility-change.js.map